import { useRouter } from 'next/router';
import Link from 'next/link';
import useProductCardPrice from 'hooks/products/useProductCardPrice';
import useWishlist from 'hooks/account/useWishlist';
import getProductImage from 'utils/getProductImage';
import styled from '@xstyled/styled-components';
import DiscountPercentBadge from './DiscountPercentBadge';
import Image from '@/UI/Image';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import ClientOnly from '@/UI/Primitives/ClientOnly';
import StarRating from '@/UI/Ratings/StarRating';
import AddToCartButton from '@/UI/Button/AddToCart';
// import { CompareButtonSmall } from '@/UI/Button/Compare';
import DeleteFavorite from '@/UI/Button/DeleteFavorite';

const MobileCardWrapper = styled.divBox`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.2rem 0.4rem 0.5rem;
  border-radius: 12px;
  border: 0.7px solid #d8d9e5;
  background-color: white;
  font-weight: 500;
  margin-top: 2rem;
  margin-right: 0.5rem;
`;

const MobileCardTitle = styled.p`
  width: 80%;
  margin-top: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 0.9rem;
  line-height: 1.5;

  @media (min-width: mobile) {
    font-size: xsmall;
  }
`;

const MobileCardPrice = styled.p`
  padding: 0.4rem 1rem 0.6rem 0;
  color: teal-200;
  font-size: xsmall;

  @media (min-width: mobile) {
    font-size: small;
    padding: 0.2rem 1rem 0.4rem 0;
  }

  @media (min-width: tablet) {
    padding: 0.6rem 1rem 0.8rem 0;
  }

  span {
    position: relative;
    margin-right: 0.5rem;
    font-size: xxsmall;
    font-weight: 500;
    color: blue-200;
    text-decoration: line-through;

    @media (min-width: mobile) {
      font-size: xsmall;
    }
  }
`;

export default function MobileProductCard({ product, ...rest }) {
  const router = useRouter();
  const favorites = router.pathname.endsWith('lemmikud');

  const price = useProductCardPrice(product?.price_range);

  const image = getProductImage({
    mainImage: product?.image,
    gallery: product?.media_gallery
  });

  const { removeFromWishlist } = useWishlist(product);

  return (
    <MobileCardWrapper {...rest}>
      {price?.discount?.percentNumber > 0 ? (
        <DiscountPercentBadge percent={'-'+ Math.round(Number(price?.discount?.percent?.replace('-','').replace(' ','').replace('kuni','').replace('%','')))+'%'} />
      ) : null}
      <Link href="/toode/[toode]" as={`/toode/${product?.url_key}`}>
        <a>
          <Image
            src={image?.url}
            alt={image?.label}
            width={190}
            height={200}
            objectFit="contain"
          />
        </a>
      </Link>
      <FlexBox dir="column" w="100%" position="relative" left={16}>
        {!favorites && product?.rating_summary > 0 && (
          <StarRating
            rating={product?.rating_summary}
            position="absolute"
            right={22}
            top={4}
            spaceX={4}
          />
        )}
        <Link href="/toode/[toode]" as={`/toode/${product?.url_key}`}>
          <a>
            <MobileCardTitle>{product?.name}</MobileCardTitle>
          </a>
        </Link>
        

        <MobileCardPrice>
          {price?.discount?.value ? (
            <span>
              {product?.price_range?.maximum_price?.regular_price?.value 
              /*
                '-' +
                Math.round(
                  Number(
                    price?.discount?.percent
                      ?.replace('-', '')
                      .replace(' ', '')
                      .replace('kuni', '')
                      .replace('%', '')
                  )
                ) +
                '%'
                  */}€
              
            </span>
          ) : null}
          {price?.value} 
        </MobileCardPrice>
        
      


        <FlexBox
          spaceX={{ _: '0.5rem', mobile: '1rem' }}
          ml={{ _: '-1rem', mobile: '-1.2rem', tablet: '-0.4rem' }}
          transform={{ _: 'scale(0.9)', tablet: 'scale(1)' }}
        >
          <ClientOnly>
            <AddToCartButton product={product} />
          </ClientOnly>
          {/* {favorites ? <DeleteFavoriteButton /> : <CompareButtonSmall />} */}
          {favorites && <DeleteFavorite onClick={() => removeFromWishlist()} />}
        </FlexBox>
      </FlexBox>
    </MobileCardWrapper>
  );
}

